import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PmProjectStatus} from './pm-multi-project-status.component';
import {Observable} from 'rxjs';
import {SuppliersService} from '../../../../services/suppliers.service';
import {DIALOG_DATA} from '@angular/cdk/dialog';
import {ConfirmDialogComponent} from "../../../dialogs/confirm-dialog.component";
import {DatePipe} from "@angular/common";
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-multi-edit-pm-status',
  templateUrl: 'multi-edit-pm-status.component.html',
  styleUrls: ['multi-edit-pm-status.component.scss'],
})
export class MultiEditPmStatusComponent implements OnInit {
  data: PmProjectStatus = {};
  metrologists$: Observable<ProleisObject[]>;
  planners$: Observable<ProleisObject[]>;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private suppliersService: SuppliersService,
    @Inject(DIALOG_DATA) private dialogData: any,
    private dialog: MatDialog,
    private datePipe: DatePipe
  ) {
  }

  ngOnInit() {
    if (this.dialogData) {
      this.metrologists$ = this.suppliersService.getPmContactExtMetrologists(
        this.dialogData.pboId,
        this.dialogData.pboPositions[0].pboPosId,
      );
      this.planners$ = this.suppliersService.getPmContactExtPlanners(
        this.dialogData.pboId,
        this.dialogData.pboPositions[0].pboPosId,
      );
    }
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => this.dismiss());
  }

  joinFields(field: string, pipe?: string): string {
    const positions = this.dialogData.pboPositions.filter(p => {
      return p[field] !== null && p[field] !== undefined && p[field] !== '';
    });
    const distinctValues = [...new Set(positions.map(p => String(p[field])))];
    switch (pipe) {
      case 'date':
        return distinctValues.map(v => this.datePipe.transform(String(v), 'shortDate')).join(',');
      case 'percent':
        return distinctValues.map(v => String(Number(v) * 100) + '%').join(', ');
      default:
        return distinctValues.map(v => String(v)).join(', ');
    }
  }

  save() {
    this.data.productionProgress = this.data.productionProgress / 100;
    this.dialogRef.close(this.data);
  }

  dismiss() {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Bestätigen',
        message: 'Möchten Sie die Eingabe wirklich verwerfen?'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close();
      }
    })
  }
}
